// Put your Javascript here - You can use ES2015 Javascript, because we use Webpack with Babel
import MuteButton from "./MuteButton";
import * as helper from "./../../../../../VX/View/Assets/Js/helper";
import axios from "axios";
import { dom, library } from "@fortawesome/fontawesome-svg-core";
import { faUser } from "@fortawesome/pro-solid-svg-icons/faUser";
import { faTimes } from "@fortawesome/pro-duotone-svg-icons/faTimes";
import { faCheck } from "@fortawesome/pro-duotone-svg-icons/faCheck";
import { faVolumeMute } from "@fortawesome/pro-solid-svg-icons/faVolumeMute";
import { faVolumeUp } from "@fortawesome/pro-solid-svg-icons/faVolumeUp";
import { faHeart } from "@fortawesome/pro-solid-svg-icons/faHeart";
import { faYoutube } from "@fortawesome/free-brands-svg-icons/faYoutube";
import { faCamera } from "@fortawesome/pro-solid-svg-icons/faCamera";
import { faFemale } from "@fortawesome/pro-solid-svg-icons/faFemale";
import { faShare } from "@fortawesome/pro-solid-svg-icons/faShare";
import { faSmile } from "@fortawesome/pro-solid-svg-icons/faSmile";
import { faImage } from "@fortawesome/pro-solid-svg-icons/faImage";
import { faGift } from "@fortawesome/pro-solid-svg-icons/faGift";

import { chatFrameHandler } from "../../../Assets/Js/ChatFrameHandler";

require("./../Sass/base.scss");

// Require babel polyfill before anything else so stupid IE can handle modern stuff like Symbols etc.
require("babel-polyfill");

library.add(
	faUser,
	faTimes,
	faCheck,
	faVolumeMute,
	faVolumeUp,
	faHeart,
	faYoutube,
	faCamera,
	faFemale,
	faShare,
	faSmile,
	faImage,
	faGift
);
dom.watch();

helper.onWindowLoadedCompletely(function () {
	const { host, ab2, ab5, ab4, max, count, adtv, extend, liked, coup, bc, hasAVSCookie, pt } = JSON.parse(
		helper.getData(helper.$(".content")[0], "info")
	);
	axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

	let fannySpecial = false;
	const Paytour = window.paytourHelper;
	let PaytourSettings = {
		pfm: 1502,
		host: host,
		hideClose: max <= count,
	};

	switch (parseInt(coup, 10)) {
		case 2:
			PaytourSettings.option = "10MVX4F";
			PaytourSettings.pc = "10MVX4F";
			break;
		case 1:
			PaytourSettings.option = "CHAT41TOP";
			break;
		case 0:
		default:
			PaytourSettings.option = "2XITGA";
			break;
	}

	if (hasAVSCookie) {
		PaytourSettings.signupParams = { az: true };
	}

	// Special handling FannyXX
	if (host === 4066266 && bc !== null) {
		PaytourSettings.option = bc;
		PaytourSettings.texts = {
			BonusTextCustom: "& erhalte 2 Videos geschenkt",
			BonusTextCustomSecondary: "Erhalte 2 exklusive Hardcore-Videos geschenkt",
			SignupActorAttraction:
				"Schnell & unverbindlich anmelden! Erhalte Zugang zu all meinen versauten Videos und zu geilen Livechats mit mir!",
		};
		PaytourSettings.successUrl = "https://www.visit-x.net/de/meinvisitx/videos-geschenkt/";
		fannySpecial = true;
		helper.hide(document.querySelector(".swipe-v2"));
	}

	if (pt === 0) {
		PaytourSettings.hideSignupConfirmation = true;
	}

	chatFrameHandler(ab4);

	const dislikeButtons = helper.$(".swipe-no");
	const likeButtons = helper.$(".swipe-yes");
	const video = helper.$("#bigvideo");
	const muteButton = helper.$(".muteButton")[0];
	const loginButton = helper.$(".login")[0];
	const chatInput = helper.$("#chat");

	new MuteButton(muteButton, video);

	function addClickButton(buttons, action) {
		for (let button of buttons) {
			helper.addEventListener(button, "click", (evt) => {
				evt.preventDefault();
				axios.post(window.location.origin + window.location.pathname, { host, adtv, action }).then((reply) => {
					let next = reply.data.nextHost;
					if (typeof next === "undefined") {
						next = 5613624;
					}

					let currentLike = liked;
					if (action === "like") {
						if (currentLike === "") {
							currentLike = host;
						} else {
							currentLike += "," + host;
						}
					}

					if (count < max || ab2 === 1) {
						window.location = `/VX/Profil/${next}?${extend}&c=${count}&ab2=${ab2}&ab5=${ab5}&coup=${coup}&likes=${currentLike}`;
					} else {
						if (pt === 0 || fannySpecial || PaytourSettings.option === "10MVX4F") {
							Paytour.openSignup(PaytourSettings);
						} else {
							Paytour.openPaytour(PaytourSettings);
						}
					}
				});
			});
		}
	}

	addClickButton(dislikeButtons, "dislike");
	addClickButton(likeButtons, "like");

	helper.addEventListener(video, "ended", () => {
		var $doYouLikeMyBodyElement = helper.$(".doYouLikeMyBody")[0];
		helper.removeClass($doYouLikeMyBodyElement, "hidden");
		helper.fadeIn($doYouLikeMyBodyElement, 1000);
	});

	helper.addEventListener(loginButton, "click", () => {
		Paytour.openLogin(PaytourSettings);
	});

	helper.addEventListener(chatInput, "keydown", (evt) => {
		if (evt.keyCode === 13) {
			if (pt === 0 || fannySpecial || PaytourSettings.option === "10MVX4F") {
				Paytour.openSignup(PaytourSettings);
			} else {
				Paytour.openPaytour(PaytourSettings);
			}
		}
	});

	if (ab2 === 1 && count > max) {
		const cta = helper.$(".overview-button")[0];
		const girls = helper.$(".girlButton");

		helper.addEventListener(cta, "click", (e) => {
			e.preventDefault();
			PaytourSettings.host = 0;
			if (pt === 0 || fannySpecial || PaytourSettings.option === "10MVX4F") {
				Paytour.openSignup(PaytourSettings);
			} else {
				Paytour.openPaytour(PaytourSettings);
			}
		});

		for (let n = 0; n < girls.length; n++) {
			const button = girls[n];
			helper.addEventListener(button, "click", (e) => {
				e.preventDefault();
				PaytourSettings.host = helper.getData(button, "id");
				if (pt === 0 || fannySpecial || PaytourSettings.option === "10MVX4F") {
					Paytour.openSignup(PaytourSettings);
				} else {
					Paytour.openPaytour(PaytourSettings);
				}
			});
		}
	} else {
		let links = helper.$(
			"#wrapper button, #wrapper a, #wrapper video, #wrapper img, #wrapper .menu li, #wrapper .vxarea li, #wrapper .foto, #wrapper .message object, #wrapper .message svg, #corona a"
		);
		for (let link of links) {
			if (!helper.hasClass(link, "nopaytour")) {
				helper.addEventListener(link, "click", () => {
					if (pt === 0 || fannySpecial || PaytourSettings.option === "10MVX4F") {
						Paytour.openSignup(PaytourSettings);
					} else {
						Paytour.openPaytour(PaytourSettings);
					}
				});
			}
		}
	}
});
